import { Color } from './color';
/**
 * Render rect in different coordinate and using color channel for stroke attribute.
 */
export const Hollow = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke' }, options), context);
};
Hollow.props = Object.assign(Object.assign({}, Color.props), { defaultMarker: 'hollowSquare' });
//# sourceMappingURL=hollow.js.map